import { FC } from 'react';
import { TGeneralComponent } from '../../types/types';
import NavLinksWithContent from '../../components/NavLinksWithContent/NavLinksWithContent';
import { TypeProductCardWithoutUnresolvableLinksResponse } from '../../_generated';
import { useSettingsContext } from '@/contexts/SettingsContext';
import { getLocalizedLink } from '@/utils/getLocalizedLink';

const HomeProductsWithDescriptionHousing: FC<{
    component: TGeneralComponent;
}> = ({ component }) => {
    const { lang } = useSettingsContext();
    return (
        <NavLinksWithContent
            navLinks={component.fields.products.map((item: any) => {
                const productItem = item as TypeProductCardWithoutUnresolvableLinksResponse;
                return {
                    label: productItem.fields.title,
                    path: getLocalizedLink(productItem.fields.link, lang) || '',
                    image: productItem?.fields?.image,
                };
            })}
            title={component.fields.subtitle}
            subtitle={component.fields.title}
            summary={component.fields.description}
            paddingTop={component.fields.paddingTop}
            paddingBottom={component.fields.paddingBottom}
        />
    );
};

export default HomeProductsWithDescriptionHousing;
